<script>

    export let value = null
    export let label = null
    export let placeholder = null
    export let icon = null
    export let iconType = 'fa'
    export let size = null
    export let step = null
    export let max = null
    export let min = null
    export let required = true
    export let readonly = null

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control has-icons-left">
        {#if icon}
            <span class="icon"><i class="fas { iconType }-{ icon }"></i></span>
        {/if}
        <input bind:value={ value } class="input is-{ size }" type="number" { readonly }  { step } { max } { min } { placeholder } { required } >
    </div>
</div>